/* VanillaGoods Baking Academy: course filter, lesson progress (this browser only), shop click tracking. */
(function () {
  if (window.__vgaInit) return;
  window.__vgaInit = true;
  var KEY = 'vga-progress-v1';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(p) {
    try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) { /* private mode: progress just isn't kept */ }
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }
  function lessonsOf(el) {
    return (el.getAttribute('data-vga-lessons') || '').split(',').filter(Boolean);
  }

  function paint() {
    var p = load();
    document.querySelectorAll('[data-vga-lesson-row]').forEach(function (row) {
      row.classList.toggle('is-done', !!p[row.getAttribute('data-vga-lesson-row')]);
    });
    document.querySelectorAll('[data-vga-course]').forEach(function (card) {
      var ls = lessonsOf(card), done = ls.filter(function (h) { return p[h]; }).length;
      var bar = card.querySelector('[data-vga-progress]');
      if (!bar || !ls.length || !done) return;
      bar.hidden = false;
      bar.querySelector('i').style.width = Math.round(100 * done / ls.length) + '%';
      bar.title = done + ' of ' + ls.length + ' lessons complete';
    });
    document.querySelectorAll('[data-vga-course-page]').forEach(function (page) {
      var rows = page.querySelectorAll('[data-vga-lesson-row]'), done = 0, next = null;
      rows.forEach(function (r) {
        if (p[r.getAttribute('data-vga-lesson-row')]) done++;
        else if (!next) next = r.querySelector('a');
      });
      var out = page.querySelector('[data-vga-course-progress]'), start = page.querySelector('[data-vga-start]');
      if (out && done) { out.hidden = false; out.textContent = done + ' of ' + rows.length + ' lessons complete'; out.style.alignSelf = 'center'; }
      if (start && done && next) { start.href = next.getAttribute('href'); start.textContent = 'Continue where you left off →'; }
    });
    var btn = document.querySelector('[data-vga-done]'), lesson = document.querySelector('[data-vga-lesson]');
    if (btn && lesson) {
      var on = !!p[lesson.getAttribute('data-vga-lesson')];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? 'Completed ✓' : 'Mark lesson complete';
    }
    var cont = document.querySelector('[data-vga-continue]'), last = p.__last;
    if (cont && last && last.url && last.title) {
      cont.hidden = false;
      cont.innerHTML = '';
      cont.appendChild(document.createTextNode('Continue learning: '));
      var a = document.createElement('a');
      a.href = last.url; a.textContent = last.title;
      cont.appendChild(a);
    }
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }

  /* Academy home: search + category + skill level over the full curriculum. */
  function filter(hub, pushUrl) {
    if (!hub) return;
    var qEl = hub.querySelector('[data-vga-q]'), lvEl = hub.querySelector('[data-vga-level]');
    var chip = hub.querySelector('[data-vga-filter][aria-pressed="true"]');
    var q = norm(qEl && qEl.value), lv = lvEl ? lvEl.value : '', cat = chip ? chip.getAttribute('data-vga-filter') : '';
    var words = q ? q.split(' ') : [];
    function hit(text) { text = norm(text); return words.every(function (w) { return text.indexOf(w) !== -1; }); }
    var lessons = 0, courses = 0;
    hub.querySelectorAll('[data-vga-group]').forEach(function (g) {
      var gShown = 0;
      var catOk = !cat || g.getAttribute('data-vga-cat') === cat;
      g.querySelectorAll('[data-vga-course-block]').forEach(function (b) {
        var ok = catOk && (!lv || b.getAttribute('data-vga-level') === lv);
        var courseHit = ok && (!q || hit(b.getAttribute('data-vga-text')));
        var shownHere = 0;
        b.querySelectorAll('[data-vga-lesson-item]').forEach(function (li) {
          var show = ok && (courseHit || hit(li.getAttribute('data-vga-text')));
          li.hidden = !show;
          if (show) shownHere++;
        });
        b.hidden = !shownHere;
        if (shownHere) { courses++; lessons += shownHere; gShown++; }
      });
      g.hidden = !gShown;
    });
    var count = hub.querySelector('[data-vga-count]'), none = hub.querySelector('[data-vga-none]');
    if (count) count.textContent = (q || lv || cat) && lessons ? lessons + ' lesson' + (lessons === 1 ? '' : 's') + ' in ' + courses + ' course' + (courses === 1 ? '' : 's') : '';
    if (none) none.hidden = !!lessons;
    if (pushUrl && window.history && history.replaceState) {
      var u = new URL(location.href);
      ['q', 'level', 'category'].forEach(function (k) { u.searchParams.delete(k); });
      if (q) u.searchParams.set('q', qEl.value.trim());
      if (lv) u.searchParams.set('level', lv);
      if (cat) u.searchParams.set('category', cat);
      history.replaceState(null, '', u.toString());
    }
  }

  function initHub(hub) {
    var u = new URL(location.href), qEl = hub.querySelector('[data-vga-q]'), lvEl = hub.querySelector('[data-vga-level]');
    if (qEl && u.searchParams.get('q')) qEl.value = u.searchParams.get('q');
    if (lvEl && u.searchParams.get('level')) lvEl.value = u.searchParams.get('level');
    var cat = u.searchParams.get('category');
    if (cat) {
      var c = hub.querySelector('[data-vga-filter="' + cat.replace(/[^a-z0-9-]/g, '') + '"]');
      if (c) hub.querySelectorAll('[data-vga-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
    }
    var t;
    if (qEl) qEl.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { filter(hub, true); }, 120); });
    if (lvEl) lvEl.addEventListener('change', function () { filter(hub, true); });
    var form = hub.querySelector('[data-vga-search-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      filter(hub, true);
      var cur = hub.querySelector('[data-vga-curriculum]');
      if (cur) cur.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('academy_search', { search_term: qEl.value.trim() });
    });
    filter(hub, false);
    var links = hub.querySelectorAll('.vga-jumpbar a');
    if ('IntersectionObserver' in window && links.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      links.forEach(function (a) { var s = document.getElementById(a.getAttribute('href').slice(1)); if (s) io.observe(s); });
    }
  }

  /* Save + share (lessons and courses). Saved items stay in this browser. */
  var SAVED = 'vga-saved-v1';
  function loadSaved() { try { return JSON.parse(localStorage.getItem(SAVED)) || {}; } catch (e) { return {}; } }
  function storeSaved(s) { try { localStorage.setItem(SAVED, JSON.stringify(s)); } catch (e) {} }
  function savedKey(box) { return box.getAttribute('data-kind') + ':' + box.getAttribute('data-handle'); }
  function toast(box, msg) {
    var t = box.querySelector('[data-vga-toast]');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 1800);
  }
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (ok, bad) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? ok() : bad(); } catch (e) { bad(e); }
      document.body.removeChild(ta);
    });
  }
  function paintSaved() {
    var s = loadSaved();
    document.querySelectorAll('[data-vga-actions]').forEach(function (box) {
      var on = !!s[savedKey(box)], btn = box.querySelector('[data-vga-save]'), lab = box.querySelector('[data-vga-save-label]');
      if (!btn) return;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (lab) lab.textContent = on ? 'Saved' : 'Save ' + box.getAttribute('data-kind');
    });
    document.querySelectorAll('[data-vga-saved]').forEach(function (sec) {
      var list = sec.querySelector('[data-vga-saved-list]'), keys = Object.keys(s).filter(function (k) { return k.indexOf('pet:') !== 0; }).sort(function (a, b) { return (s[b].t || 0) - (s[a].t || 0); });  // pet: = Pastry Pets saves (My Kitchen only)
      sec.hidden = !keys.length;
      var hub = sec.closest('[data-vga-hub]'), link = hub && hub.querySelector('[data-vga-saved-link]');
      if (link) link.hidden = !keys.length;
      if (!list) return;
      list.innerHTML = '';
      keys.forEach(function (k) {
        var it = s[k], li = document.createElement('li'), wrap = document.createElement('span'), a = document.createElement('a'), sm = document.createElement('small'), rm = document.createElement('button');
        a.href = it.url; a.textContent = it.title;
        sm.textContent = (it.kind === 'course' ? 'Course' : 'Lesson') + (it.sub ? ' · ' + it.sub : '');
        wrap.appendChild(a); wrap.appendChild(sm);
        rm.type = 'button'; rm.textContent = 'Remove'; rm.setAttribute('data-vga-unsave', k); rm.setAttribute('aria-label', 'Remove ' + it.title);
        li.appendChild(wrap); li.appendChild(rm); list.appendChild(li);
      });
    });
  }
  function initActions() {
    document.addEventListener('click', function (e) {
      var save = e.target.closest('[data-vga-save]');
      if (save) {
        var box = save.closest('[data-vga-actions]'), s = loadSaved(), k = savedKey(box);
        if (s[k]) { delete s[k]; toast(box, 'Removed from saved'); }
        else {
          s[k] = { kind: box.getAttribute('data-kind'), title: box.getAttribute('data-title'), url: box.getAttribute('data-url'), sub: box.getAttribute('data-sub'), t: Date.now() };
          toast(box, 'Saved. Find it on the Academy page.');
          track('academy_save', { kind: s[k].kind, item: box.getAttribute('data-handle') });
        }
        storeSaved(s); paintSaved();
        return;
      }
      var un = e.target.closest('[data-vga-unsave]');
      if (un) { var s2 = loadSaved(); delete s2[un.getAttribute('data-vga-unsave')]; storeSaved(s2); paintSaved(); return; }
      var sum = e.target.closest('[data-vga-share] > summary');
      if (sum && navigator.share && window.matchMedia && matchMedia('(pointer: coarse)').matches) {
        e.preventDefault();
        var b = sum.closest('[data-vga-actions]');
        navigator.share({ title: b.getAttribute('data-title'), url: location.origin + b.getAttribute('data-url') })
          .then(function () { track('academy_share', { method: 'native', item: b.getAttribute('data-handle') }); }, function () {});
        return;
      }
      var cp = e.target.closest('[data-vga-copy]');
      if (cp) {
        var bx = cp.closest('[data-vga-actions]');
        copyText(cp.getAttribute('data-vga-copy')).then(function () { toast(bx, 'Link copied'); }, function () { toast(bx, 'Copy failed'); });
        cp.closest('details').open = false;
        track('academy_share', { method: 'copy', item: bx.getAttribute('data-handle') });
        return;
      }
      var to = e.target.closest('[data-vga-share-to]');
      if (to) {
        var bt = to.closest('[data-vga-actions]');
        track('academy_share', { method: to.getAttribute('data-vga-share-to'), item: bt.getAttribute('data-handle') });
        to.closest('details').open = false;
      }
      document.querySelectorAll('[data-vga-share][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-vga-share][open]').forEach(function (d) { d.open = false; });
    });
    paintSaved();
  }

  function init() {
    var lesson = document.querySelector('[data-vga-lesson]');
    if (lesson) {
      var p = load(), h1 = lesson.querySelector('h1');
      p.__last = { url: location.pathname, title: h1 ? h1.textContent.trim() : '' };
      save(p);
      track('academy_lesson_view', { lesson: lesson.getAttribute('data-vga-lesson'), course: lesson.getAttribute('data-vga-course-handle') });
    }
    document.addEventListener('click', function (e) {
      var done = e.target.closest('[data-vga-done]');
      if (done && lesson) {
        var p = load(), h = lesson.getAttribute('data-vga-lesson');
        if (p[h]) delete p[h]; else { p[h] = Date.now(); track('academy_lesson_complete', { lesson: h }); }
        save(p);
        paint();
        return;
      }
      var chip = e.target.closest('[data-vga-filter]');
      if (chip) {
        chip.parentNode.querySelectorAll('[data-vga-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        filter(chip.closest('[data-vga-hub]'), true);
        return;
      }
      var reset = e.target.closest('[data-vga-reset]');
      if (reset) {
        var hub = reset.closest('[data-vga-hub]'), q = hub.querySelector('[data-vga-q]'), lv = hub.querySelector('[data-vga-level]');
        if (q) q.value = '';
        if (lv) lv.value = '';
        var all = hub.querySelector('[data-vga-filter=""]');
        if (all) all.click(); else filter(hub, true);
        return;
      }
      var shop = e.target.closest('[data-vga-shop]');
      if (shop) track('academy_shop_click', { list: shop.getAttribute('data-vga-shop'), url: shop.getAttribute('href') });
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.closest && f.closest('.vga-prod')) track('academy_add_to_cart', { url: location.pathname });
      if (f.closest && f.closest('.vga-signup')) track('academy_guide_signup', { url: location.pathname });
    });
    document.querySelectorAll('[data-vga-hub]').forEach(initHub);
    initActions();
    window.addEventListener('vgme:change', function () { paintSaved(); paint(); });
    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
